export default "__VITE_ASSET__97199af9__"